import React from 'react';
import { Autocomplete } from '@react-google-maps/api';
import { useIntl } from 'react-intl';

import * as S from './styles';
import { CloseOutlined } from '@ant-design/icons';

const countryRestrictions = { country: ['ca'] };

function AddressField(props) {
  const intl = useIntl();
  const { id, setRef, setPlace, icon, position } = props;
  const { placeholder, address, changeAddressInput, clearAddressInput } = props;

  return (
    <>
      <S.Row>
        {icon}
        <p>{intl.formatMessage({ id: `model.${id}Label` })}</p>
      </S.Row>
      <S.Row>
        <Autocomplete
          fields={['address_components', 'formatted_address', 'geometry']}
          restrictions={countryRestrictions}
          onLoad={setRef}
          className="autocomplete-input"
          onPlaceChanged={setPlace}
          // NOTE Set bound restriction to show closer location first from map position
          bounds={{
            north: position.lat + 1,
            south: position.lat - 1,
            east: position.lng + 1,
            west: position.lng - 1,
          }}
        >
          <S.Input
            id={id}
            type="text"
            value={address[`${id}Input`]}
            onChange={changeAddressInput}
            failed={address[`${id}Failed`]}
            placeholder={intl.formatMessage({ id: placeholder })}
          />
        </Autocomplete>
        <S.ClearInput
          failed={address[`${id}Failed`]}
          onClick={() => clearAddressInput(id)}
        >
          <CloseOutlined />
        </S.ClearInput>
      </S.Row>
      {address[`${id}Failed`] && (
        <S.Error>{intl.formatMessage({ id: 'error.invalidAddress' })}</S.Error>
      )}
    </>
  );
}

// MONTREAL POSITION BASE
AddressField.defaultProps = {
  position: {
    lat: 45,
    lng: -73,
  },
};

export default AddressField;
